<div class="api-keys-edit-component scroll-container fullpage">
  <div class="row">
    <div class="col content-col">

      <!-- ApiKey Form -->
      @if (api_key) {
        <div>
          <api-keys-edit-form [model]="model$ | async" [disabled]="disableForm" [tenantId]="tenant_id" (saveForm)="saveApiKey($event)"></api-keys-edit-form>
        </div>
      } @else {
        <div class="alert alert-warning" role="alert">
          @if (id === null) {
            <span i18n="@@components.api_keys.not_found">
            There is no api key with the given id.
          </span>
          } @else {
            <ng-container i18n="@@common.loading_text">We're loading… please wait.</ng-container>
          }
        </div>
      }
      <!-- ApiKey Form end -->

      <!-- No Results -->
      <!-- No Results end -->

    </div>
  </div>
</div>
